module.exports = __webpack_public_path__ + "img/aboutUsImg03.12cdf516.png";